import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import * as Request from '../tgccRequest';


const RosterTypes ={
    TBanker: "TBanker",
};

const outerLinkDiv = {
    marginBottom:'15px'
}

const linkLabel: React.CSSProperties = {
    fontWeight:700,
    fontSize:'20px'
}

class Props extends Tgcc.BaseProps{
    rosterCode: string;
}
class _PurchaseLinks extends React.Component<Props, any>{
    state = { 
        rosterCode: null,
        rosterType: null,
    };


    init = (props: Props) => {
        if(props.state.LoginData && props.rosterCode)
            Request.getRoster(this.props.state.LoginData, props.rosterCode, this.rosterLoaded, this.loadError);
    }

    componentWillMount(){
        this.init(this.props);
    }
    
    componentWillReceiveProps(props: Props){
        this.init(props);
    }

    rosterLoaded = (data: any) => {
        this.setState({
            rosterType: data.rosterType,
            rosterCode: data.rosterCode,
        });
    }

    loadError = (err: any) => {
        console.log("error loading roster: ", err);
    }

    getRosterLink = () => {
        var tBanker = "https://www.thegraphiccowcompany.com/tbanker/";
        if(this.state.rosterType == RosterTypes.TBanker){
            return (
            <div style={outerLinkDiv}>
                <div style={linkLabel}>T-Banker Sign Up By Roster Code:</div> 
                    <a className="hoverBorder" href={tBanker + this.state.rosterCode}>{tBanker + this.state.rosterCode}</a>
            </div>
            )
        }
    }
    render (){
        var rosterLink = this.getRosterLink();
        
        return (
            <div>
                {rosterLink}
            </div>
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var PurchaseLinks = connect(mapStateToProps)(Radium(_PurchaseLinks));